import React from "react";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { CustomAutocomplete } from "./AutoComplete";

export const ProductsAutoComplete = ({ value, onChange }) => {
  const products = useSelector((state) => state.products.products);

  return (
    <CustomAutocomplete
    options={products}
    getOptionLabel={(option) => option.name_english}
    value={value}
    onChange={onChange}
    label="Select Product"
  />
  );
};
